import {Button, CardContent, CircularProgress, Typography, useTheme} from '@mui/material';
import {styled} from '@mui/material/styles';
import * as React from 'react';
import {Form, LoginFormClasses, maxLength, minLength, required, TextInput, useNotify, useSafeSetState, useTranslate} from 'react-admin';
import AuthProvider from '../../providers/AuthProvider';


export const TOTPForm = (props) => {
	const {className} = props;
	const [loading, setLoading] = useSafeSetState(false);
	const translate = useTranslate();
	const notify = useNotify();
	const theme = useTheme();

	const submit = (values) => {
		setLoading(true);
		AuthProvider.sendMFACode(values.totpCode).then(() => {
			setLoading(false);
		}).catch((err) => {
			setLoading(false);
			notify(err, {
				type: 'error'
			});
		});
	};

	return (
		<StyledForm onSubmit={submit} mode="onChange" noValidate className={className}>
			<CardContent className={LoginFormClasses.content}>

				<Typography variant="body1" color="text.secondary" sx={{marginBottom: theme.spacing(2), textAlign: 'center'}}>
					{translate('proactive.login.totp_challenge_needed')}
				</Typography>

				<TextInput
					autoFocus
					source="totpCode"
					label={translate('proactive.login.labels.totp_code')}
					type="text"
					autoComplete="off"
					validate={[required(), minLength(6), maxLength(6)]}
					fullWidth
				/>

				<Button
					variant="contained"
					type="submit"
					color="secondary"
					disabled={loading}
					fullWidth
					className={LoginFormClasses.button}
				>
					{loading ? (
						<CircularProgress
							className={LoginFormClasses.icon}
							size={19}
							thickness={3}
						/>
					) : (
						translate('ra.action.confirm')
					)}
				</Button>
			</CardContent>
		</StyledForm>
	);
};

const StyledForm = styled(Form, {
	overridesResolver: (props, styles) => styles.root
})(({theme}) => ({
	[`& .${LoginFormClasses.content}`]: {
		width: 300
	},
	[`& .${LoginFormClasses.button}`]: {
		marginTop: theme.spacing(2)
	},
	[`& .${LoginFormClasses.icon}`]: {
		margin: theme.spacing(0.3)
	}
}));